'use client'

import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import styles from './WalletSign.module.css'
import Input from '@/components/contained-input'
import Button from '@/components/button'
import ButtonOutlined from '@/components/button-outlined'
import Loading from '@/components/circle-loading'
import copy from 'copy-to-clipboard'
import Wallet from '@/utils/wallet'
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined'

const WalletSign: FC<{
	className?: string
	handleModalClose?: () => void
}> = (props): ReactElement => {
	const { className } = props
	const [loading, setLoading] = React.useState(false)
	const [showCopied, setShowCopied] = React.useState(false)
	const [value, setValue] = React.useState('')
	const [signature, setSignature] = React.useState('')
	const handleChange = React.useCallback((evt: any) => setValue(evt.target.value), [])

	const handleSubmit = React.useCallback(
		async (evt: any) => {
			evt.preventDefault()
			evt.stopPropagation()
			setLoading(true)
			const { success, signature: r } = await Wallet.signMessage(value)
			if (success) {
				setSignature((r as any))
			}
			setLoading(false)
		},
		[value]
	)

	return (
		<div className={classNames({ [(props.className as any)]: !!className }, styles.root)}>
			<div className={styles.header}>
				<div />
				<div className={classNames(styles.title, 'display-md', 'semibold')}>Sign message</div>
				<DisabledByDefaultOutlinedIcon onClick={props.handleModalClose} style={{ fontSize: 40 }} />
			</div>
			<div className={classNames(styles.description, 'text-md', 'regular')}>
				Sign a message to prove you own this wallet
			</div>
			<form onSubmit={handleSubmit} className={styles.form}>
				<Input
					inputClassName={styles.input}
					value={value}
					onChange={handleChange}
					placeholder="Message"
				/>
				<Button size="small" background="white" className={styles.button} type="submit">
					{loading ? <Loading className={styles.loading} /> : 'Sign'}
				</Button>
			</form>
			{signature && (
				<div className={styles.signatureContainer}>
					<p className={classNames(styles.signature, 'text-sm', 'medium')}>{signature}</p>
					<ButtonOutlined
						size="small"
						className={styles.copyButton}
						onClick={() => {
							setShowCopied(true)
							copy(signature)
							setTimeout(() => setShowCopied(false), 1500)
						}}
					>
						{showCopied ? 'Copied!' : 'Copy signature'}
					</ButtonOutlined>
				</div>
			)}
		</div>
	)
}

export default WalletSign
